<template>
  <div id="search-tree">
    <el-dialog
      :title="title"
      :visible.sync="treeVisible"
      width="679px"
      :before-close="handleClose"
    >
      <el-input v-model="keyWord" style="width:240px;" show-checkbox placeholder="请输入内容" />
      <div class="tree-content">
        <el-tree
          :key="key"
          ref="tree"
          :node-key="fid"
          :check-strictly="!isCheckBox"
          show-checkbox
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          :default-checked-keys="defaultList"
          @node-click="handleNodeClick"
          @check-change="handleClick"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import service from '@/utils/request'
export default {
  props: {
    title: {
      type: String,
      default: '部门'
    },
    treeVisible: {
      type: [Boolean]
    },
    searchUrl: {
      type: [String],
      default: ''
    },
    searchParams: {
      type: [Object],
      default: () => {}
    },
    label: {
      type: [String],
      default: 'fname'
    },
    fid: {
      type: [String],
      default: 'fid'
    },
    parentId: {
      type: [String],
      default: 'FParentId'
    },
    isCheckBox: {
      type: [Boolean],
      default: false
    },
    defaultArr: {
      type: [Array],
      default: () => []
    },
    shieldHighestNode: {
      type: [Boolean],
      default: false
    },
    shieldParentNode: {
      type: [Boolean],
      default: false
    },
    showAll: {
      type: [Boolean],
      default: true
    },
    isSelectParent: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      keyWord: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedId: null,
      checkedData: null,
      defaultList: [],
      key: 0,
      copyData: []
    }
  },
  watch: {
    treeVisible(val) {
      if (val) {
        const arr = JSON.parse(JSON.stringify(this.copyData))
        arr && arr.forEach((t, i) => {
          if (!this.showAll && t[this.label] == '所有部门') {
            arr.splice(i, 1)
          }
        })
        this.toTree(arr)
        this.defaultList = this.defaultArr
        this.key++
      } else {
        this.defaultList = []
      }
    },
    keyWord(val) {
      this.$refs.tree.filter(val)
    }
  },
  created() {
    this.getTreeData()
  },
  methods: {
    clear() {
      this.data = JSON.parse(JSON.stringify(this.data))
    },
    getValue() {
      return this.getSimpleCheckedNodes(this.$refs.tree.store)
    },
    // 只获取父节点数据
    getSimpleCheckedNodes(store) {
      const _this = this
      const checkedNodes = []
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes
        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push(child.data)
          }
          if (child.indeterminate || _this.isSelectParent) {
            traverse(child)
          }
        })
      }
      traverse(store)
      return checkedNodes
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getTreeData() {
      service({
        url: this.searchUrl,
        method: 'post',
        params: {
          keyword: ''
        }
      })
        .then(res => {
          this.copyData = JSON.parse(JSON.stringify(res.data))
          this.toTree(res.data)
        })
    },
    toTree(data) {
      const obj = {} // 使用对象重新存储数据
      const res = [] // 存储最后结果
      const len = data.length
      // 遍历原始数据data，构造obj数据，键名为id，值为数据
      for (let i = 0; i < len; i++) {
        data[i].label = data[i][this.label]
        obj[data[i][this.fid]] = data[i]
      }
      // 遍历原始数据
      for (let j = 0; j < len; j++) {
        const list = data[j]
        // 通过每条数据的 pid 去obj中查询
        const parentList = obj[list[this.parentId]]
        if (parentList) {
          // 根据 pid 找到的是父节点，list是子节点，
          if (!parentList['children']) {
            parentList['children'] = []
          }
          // 将子节点插入 父节点的 children 字段中
          parentList['children'].push(list)
          if (this.shieldParentNode) {
            parentList['disabled'] = true
          }
        } else {
          // pid 找不到对应值，说明是根结点，直接插到根数组中
          res.push(list)
        }
      }
      this.$nextTick(() => {
        if (this.shieldHighestNode) {
          res[0]['disabled'] = true
        }
      })
      this.data = res
    },
    confirm() {
      this.$emit('treeConfirm', this.$refs.tree.getCheckedNodes()[0])
      this.checkedData = null
    },
    handleClose() {
      this.checkedData = null
      this.$emit('treeClose', false)
    },
    handleNodeClick(data, children, node) {
    //   this.checkedData = data
    //   this.checkedId = data[this.fid]
    //   this.$refs.tree.set
    },
    handleClick(data, checked, node) {
      if (!this.isCheckBox && !this.isSelectParent) {
        if (checked === true) {
          this.checkedData = data
          this.checkedId = data[this.fid]
          this.$refs.tree.setCheckedNodes([data])
        } else {
          this.checkedData = null
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
#search-tree {
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
    .tree-content {
        margin-top: 10px;
        height: 323px;
        overflow: auto;
    }
}
</style>
<style lang='scss'>
#search-tree {
    .tree-content {
        .el-tree-node__label {
            font-size: 16px;
        }
    }
    .el-dialog {
        position: relative;
        top: 45% !important;
        height: 518px !important;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        height: 405px !important;
        padding: 20px 35px 0 !important;
        border-bottom: 1px solid #C4CBD7;
    }
    .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: right;
        height: 73px;
        padding: 0;
        padding-right: 35px;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
}
</style>
